<template>
  <div id="">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="商品编码或名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="primary" v-on:click="getInfos">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="info" @click="addInfo">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table :data="infoList" style="width: 100%">
      <!--<el-table-column prop="id" label="id" width="50"></el-table-column>-->
      <el-table-column prop="saleType" label="出货类型" width="100"></el-table-column>
      <el-table-column prop="typeName" label="商品类型" show-overflow-tooltip width="180"></el-table-column>
      <el-table-column prop="num" label="数量" width="80"></el-table-column>
      <el-table-column prop="costPrice" label="成本价" width="100"></el-table-column>
      <el-table-column prop="salePrice" label="售价" width="100"></el-table-column>
      <el-table-column prop="express" label="快递公司" width="100"></el-table-column>
      <el-table-column prop="expressNumber" label="快递单号" show-overflow-tooltip width="180"></el-table-column>
      <el-table-column prop="expressPrice" label="快递费" width="100"></el-table-column>
      <el-table-column prop="modifyTime" label="操作时间" width="160"></el-table-column>
      <!--第二步  开始进行修改和查询操作-->
      <el-table-column label="操作" fixed="right" align="center" min-width="100">
        <template slot-scope="scope">
          <el-button type="primary" @click="checkDetail(scope.row)">详情</el-button>
          <el-button type="danger" @click="deleteInfo(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination" style="text-align: right; padding-right: 19px; padding-top: 7px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageNum"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
    <!--新增界面-->
    <el-dialog title="" :visible.sync="dialogVisible" width="70%" :close-on-click-modal="false">
      <el-form :model="addFormData" :rules="rules2" :disabled="!addFlag" ref="addFormData" label-width="150px" class="demo-ruleForm">
        <el-row>
          <el-col :span="8">
            <el-form-item prop="typeCode" label="商品类型">
              <el-select v-model="addFormData.typeCode" @change="changeSelectList" placeholder="商品类型">
                <el-option v-for="item in selectTypeList" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-table v-if="addFlag" :data="infoSubList" :header-cell-style="headerStyle" style="width: 100%" max-height="300">
          <el-table-column prop="company" label="厂家" min-width="150"></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="100"></el-table-column>
          <el-table-column prop="num" label="数量" min-width="80"></el-table-column>
          <el-table-column prop="price" label="单价" min-width="80"></el-table-column>
          <el-table-column prop="totalPrice" label="总价" min-width="80"></el-table-column>
          <el-table-column prop="remainNum" label="剩余数量" min-width="80"></el-table-column>
          <el-table-column prop="express" label="快递公司" min-width="100"></el-table-column>
          <el-table-column prop="expressNumber" label="快递单号" min-width="100"></el-table-column>
          <el-table-column prop="expressPrice" label="快递费" min-width="80"></el-table-column>
          <el-table-column prop="modifyTime" label="操作时间" min-width="180"></el-table-column>
          <el-table-column label="操作" align="center" fixed="right" min-width="100">
            <template slot-scope="scope">
              <el-button type="primary" @click="selectRow(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="infoSubSelectList" :header-cell-style="headerStyle" style="width: 100%" max-height="300">
          <el-table-column prop="company" label="厂家" min-width="180"></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="180"></el-table-column>
          <el-table-column prop="num" label="数量" min-width="80"></el-table-column>
          <el-table-column prop="price" label="单价" min-width="80"></el-table-column>
          <el-table-column prop="totalPrice" label="总价" min-width="100"></el-table-column>
          <el-table-column prop="remainNum" label="剩余数量" min-width="80"></el-table-column>
          <el-table-column prop="" label="本次出货数量" min-width="100">
            <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.thisNum" @blur="checkRow(scope.row)" placeholder="本次出货数量"></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="addFlag" label="操作" fixed="right" align="center" min-width="100">
            <template slot-scope="scope">
              <el-button type="danger" @click="deleteRow(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="saleType" label="出货类型">
              <el-select v-model="addFormData.saleType" placeholder="出货类型">
                <el-option label="销售" value="销售"></el-option>
                <el-option label="退货" value="退货"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="num" label="出货总数">
              <el-input type="text" :readonly="true" v-model.trim="addFormData.num" placeholder="总数"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="costPrice" label="成本总价">
              <el-input type="text" :readonly="true" v-model.trim="addFormData.costPrice" placeholder="总价"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
          <el-form-item prop="salePrice" label="出货总价">
            <el-input type="text" v-model.trim="addFormData.salePrice" placeholder="售价"></el-input>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="express" label="快递公司">
              <el-select v-model="addFormData.express" placeholder="快递公司">
                <el-option v-for="item in selectExpressList" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="expressNumber" label="快递单号">
              <el-input type="text" v-model="addFormData.expressNumber" placeholder="快递单号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="expressPrice" label="快递费">
              <el-input type="text" v-model="addFormData.expressPrice" placeholder="快递费默认为0元"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="remark" label="备注">
              <el-input type="text" v-model="addFormData.remark" placeholder="备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click.native="dialogVisible = false,addFormData={id:'',typeCode:'',typeName:''}">取 消</el-button>
          <el-button v-if="isView" type="primary" @click.native="addSubmit">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
    api
} from '../../api/login';
import axios from 'axios';
import qs from 'qs';
export default {
    name: 'home',
    data() {
        return {
          addFlag: true,
          infoList: [],
          infoSubList: [],
          infoSubSelectList: [],
            addFormReadOnly: true,
            dialogVisible: false,
            isView: true,
            addFormData: {
              id: '',
              saleType: '',
              typeCode: '',
              num: '',
              costPrice: '',
              salePrice: '',
              express: '',
              expressNumber: '',
              expressPrice: '',
              remark: '',
              yogaSaleSubList:[]
            },
            rules2: {
              saleType: [{required: true,message: '出货类型不能为空',trigger: 'blur'}],
              typeCode: [{required: true,message: '产品类型不能为空',trigger: 'blur'}],
              num: [{ required: true, message: '出货数量不能为空', trigger: 'blur'}],
              costPrice: [{ required: true, message: '成本总价不能为空', trigger: 'blur'}],
              salePrice: [{ required: true, message: '出货总价不能为空', trigger: 'blur' },
                {
                  validator (rule, value, callback) {
                    if(value == 0){
                      //允许0
                      callback()
                    }else if (/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
                      callback()
                    } else {
                      callback(new Error('请输入非负数字，最多两位小数'))
                    }
                  },
                  trigger: 'blur'
                }],
              express: [{ required: true, message: '快递公司不能为空', trigger: 'blur'}],
              expressPrice: [
                {
                  validator (rule, value, callback) {
                    if(value == 0){
                      //允许0
                      callback()
                    }else if(/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
                      callback()
                    } else {
                      callback(new Error('请输入非负数字，最多两位小数'))
                    }
                  },
                  trigger: 'blur'
                }]
            },

            filters: {
                name: ''
            },

            cur_page:1,//默认在第一页
            pageNum:10,//默认每页显示1条数据
            totalCount:1 //默认总条数为一条
        }
    },
    mounted: function () {
        this.loadData();
    },
    computed: {
      selectTypeList() {//初始化下拉框动态数据
        let obj = [];
        let param = {};
        axios.get('/yogaProductType/allList',qs.stringify(param)).then((result) => {
          //console.info(result);
          if(result.data.code == 0) {
            result.data.data.forEach((item, index) => {//关键的是将后台返回的数据进行遍历，并封装好
              obj.push({
                id: item.typeCode,//id必须品啊
                name: item.typeName//name必须品啊
              });
            });
          }
        });
        return obj;
      },
      selectExpressList() {//快递公司
        let obj = [];
        axios.get('/yogaParam/catalogList?catalog=express').then((result) => {
          //console.info(result);
          if(result.data.code == 0) {
            result.data.data.forEach((item, index) => {//关键的是将后台返回的数据进行遍历，并封装好
              obj.push({
                id: item.paramCode,//id必须品啊
                name: item.paramName//name必须品啊
              });
            });
          }
        });
        return obj;
      }
    },
    methods: {
        handleSizeChange(val) {
          this.pageNum=val;//获取page-sizes里的每页显示几条数据的值，赋给我们自定义的每页显示数量的变量pageNum
          this.loadData();//展示页面信息
        },
        handleCurrentChange(val) {
          this.cur_page = val;
          this.loadData();//确定当前页面后刷新页面
        },
        loadData() {
            let param = {current:this.cur_page,size:this.pageNum,filter:this.filters.name};
            axios.post('/yogaSale/list', param).then((result) => {
            //console.info(result);
            if(result.data.code == 0){
              var _data = result.data.data.records;
              this.infoList = _data;
              this.cur_page=result.data.data.current;//默认在第一页
              this.pageNum=result.data.data.size;//默认每页显示1条数据
              this.totalCount=result.data.data.total;//默认总条数为一条
            }else{
              this.$message({
                type: 'info',
                message: `查询数据失败`
              });
            }
          });
        },
        getInfos() {
            this.loadData();
        },
        addInfo() {
            this.clearAddFormData();
            this.isView = true;
            this.dialogVisible = true;
            this.addFlag = true;
        },
        changeSelectList(value){
          //拿到选中的value值
          this.clearAddFormData();
          this.addFormData.typeCode = value;
          axios.post('/yogaInport/listByTypeCode?typeCode='+value).then((result) => {
            //console.info(result);
            if(result.data.code == 0){
              var _data = result.data.data;
              this.infoSubList = _data;
            }else{
              this.$message({
                type: 'info',
                message: `查询数据失败`
              });
            }
          });
        },
        //清除新增页面参数
        clearAddFormData(){
          this.infoSubList=[];
          this.infoSubSelectList=[];
          this.addFormData= {
            id: '',
            saleType: '',
            typeCode: '',
            num: '',
            costPrice: '',
            salePrice: '',
            express: '',
            expressNumber: '',
            expressPrice: '',
            remark: '',
            yogaSaleSubList:[]
          };
        },
        //选择进货单-删除被选择列
        delInfoSubList(id){
          var index = this.infoSubList.findIndex(item =>{
            if(item.id==id){
              return true;
            }
          })
          this.infoSubList.splice(index,1);
        },
        //选择进货单
        selectRow(rowData){
          var selectData = Object.assign({}, rowData);
          this.infoSubSelectList.push(selectData);
          this.delInfoSubList(rowData.id);
        },
        countSelected(){
          //已选数量，和总金额
          let num = 0;
          let costPrice = 0;
          for (let index = 0; index < this.infoSubSelectList.length; index++) {
            let fillNum = this.infoSubSelectList[index].thisNum;
            let thisNum = 0;
            console.info(this.infoSubSelectList[index]);
            console.info(fillNum);
            if(fillNum=='' || typeof(fillNum)=='undefined'){
              thisNum = 0
            }else{
              thisNum = parseInt(fillNum);
            }
            num += thisNum;
            costPrice += thisNum*parseFloat(this.infoSubSelectList[index].price).toFixed(2);
          }
          this.addFormData.num = num;
          this.addFormData.costPrice = parseFloat(costPrice).toFixed(2);
        },
        //删除已选择进货单-删除选中数据
        delInfoSubSelectList(id){
          var index = this.infoSubSelectList.findIndex(item =>{
            if(item.id==id){
              return true;
            }
          })
          this.infoSubSelectList.splice(index,1);
        },
        //删除已选择进货单
        deleteRow(rowData){
          rowData.thisNum='';
          var selectData = Object.assign({}, rowData);
          this.infoSubList.push(selectData);
          this.delInfoSubSelectList(rowData.id);
          this.countSelected();
        },

        checkRow(rowData){
          var remainNum= rowData.remainNum;
          var thisNum = rowData.thisNum;
          if (!/^[0-9]*[1-9][0-9]*$/.test(thisNum)){
            this.$message({
              type: 'error',
              message: '只能填写正整数'
            });
            rowData.thisNum='';
          }else if(thisNum>remainNum){
            this.$message({
              type: 'error',
              message: '不能大于剩余数量'
            });
            rowData.thisNum='';
          }
          this.countSelected();
        },

        checkDetail(rowData) {
            this.clearAddFormData();
            this.addFormData = Object.assign({}, rowData);
           // this.infoSubList
            let saleId = rowData.id;
            axios.get('/yogaSaleSub/list?saleId='+saleId).then((result) => {
              //console.info(result);
              if(result.data.code == 0) {
                this.infoSubSelectList = result.data.data;
              }
            });

            this.isView = false;
            this.dialogVisible = true;
            this.addFlag = false;
        },
        deleteInfo(rowData) {
          this.$confirm('是否删除这条记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            axios.post("/yogaSale/delete?id="+rowData.id).then((result) => {
              //console.info(result);
              if(result.data.code == 0){
                  this.$message({
                    type: 'success',
                    message: "删除成功"
                  });
                this.loadData();
              }else{
                this.$message({
                  type: 'error',
                  message: result.data.message
                });
              }
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });

        },
        //增加一条记录
        addSubmit() {
            //先判断表单是否通过了判断
            this.$refs.addFormData.validate((valid) => {
                //代表通过验证 ,将参数传回后台
                if (valid) {
                    //已选择出货的进货单本次出货数量不能为空
                    for (let index = 0; index < this.infoSubSelectList.length; index++) {
                      let fillNum = this.infoSubSelectList[index].thisNum;
                      if(fillNum=='' || typeof(fillNum)=='undefined' || typeof(fillNum)=='0'){
                        this.$message({
                          type: 'error',
                          message: '已选择出货的进货单本次出货数量不能为空',
                        });
                        return;
                      }
                    }

                    this.addFormData.yogaSaleSubList = this.infoSubSelectList;
                    console.error(this.addFormData);
                    let param = Object.assign({}, this.addFormData);
                    axios.post("/yogaSale/submit", param).then((result) => {
                        console.info(result);
                        if (result.data.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '保存成功',
                            });
                            this.loadData();
                        } else {
                          var msg = result.data.message;
                            this.$message({
                                type: 'error',
                                message: msg,
                            });
                        }
                        this.dialogVisible = false;
                    });
                }
            });
        },
      headerStyle(){
        return 'background:#FFE4C4;';
      }

    }

}
</script>



// WEBPACK FOOTER //
// src/components/yoga/YogaSale.vue